import { Icon } from "@sellar-io/components";

export const NavigationOverlayEmptyState = ({
  kind,
}: {
  kind: "messages" | "notifications";
}) => (
  <div role="status" className="flex items-center gap-3 p-3">
    <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-purple-100 text-purple-700">
      <Icon icon="CHECK" size="24px" />
    </span>
    <div className="min-w-0">
      <p className="text-sm leading-5 font-semibold text-zinc-800">
        You’re all caught up
      </p>
      <p className="mt-0.5 text-sm leading-5 text-zinc-500">
        No new {kind} to show
      </p>
    </div>
  </div>
);
